// import logo from './logo13-02-22.png';
import './App.css'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Spinner from 'react-bootstrap/Spinner'
import React from 'react'
import axios from 'axios'
import { Modal } from 'react-bootstrap'
const CACHE_TTL_MS = 10 * 60 * 1000

const getResultCacheKey = (roll) => `dpr-result-${roll}`

const readResultCache = (roll) => {
  if (!roll) return null
  try {
    const raw = localStorage.getItem(getResultCacheKey(roll))
    if (!raw) return null
    const parsed = JSON.parse(raw)
    if (Date.now() - parsed.timestamp > CACHE_TTL_MS) {
      localStorage.removeItem(getResultCacheKey(roll))
      return null
    }
    return parsed.data
  } catch {
    return null
  }
}

const writeResultCache = (roll, data) => {
  if (!roll) return
  try {
    localStorage.setItem(
      getResultCacheKey(roll),
      JSON.stringify({ timestamp: Date.now(), data })
    )
  } catch {}
}

export default function App() {
  const [roll, setRoll] = React.useState('')
  const [result, setResult] = React.useState(null)
  const [error, setError] = React.useState(null)
  const [seasonInfo, setSeasonInfo] = React.useState(null)
  const [seasonError, setSeasonError] = React.useState('')
  const [loading, setLoading] = React.useState(false)
  const seasonReady = seasonInfo?.isCurrent && seasonInfo?.resultDeclared
  const showPendingMessage = seasonInfo?.isCurrent && !seasonInfo?.resultDeclared
  const showMaintenanceMessage = seasonError === 'Result Not Declared Yet'
  const PRINT = () => {
    window.print();
  }

  React.useEffect(() => {
    axios
      .get('https://cp.sikhmissionarycollege.org/dpr/result/check/season', {
        headers: {
          Accept: 'application/json',
          // 'Access-Control-Allow-Origin': '*',
        },
      })
      .then((res) => {
        if (res.data?.status === 'success') {
          setSeasonInfo(res.data.data ?? null)
          setSeasonError('')
        } else {
          setSeasonInfo(null)
          setSeasonError(res.data?.message ?? 'Unable to verify the season yet.')
        }
      })
      .catch(() => {
        setSeasonInfo(null)
        setSeasonError('Unable to verify the season yet.')
      })
  }, [])
  const submit = () => {
    if (!roll) return
    if (!seasonReady) {
      setResult(null)
      setError(
        showPendingMessage
          ? `Results for ${seasonInfo?.name ?? 'this season'} have not been declared yet.`
          : 'Results are not available right now. Please try again soon.'
      )
      return
    }
    const cachedResult = readResultCache(roll)
    if (cachedResult) {
      setError(null)
      setResult(cachedResult)
      window.scrollTo({ top: 500, behavior: 'smooth' })
      return
    }
    setError(null)
    setResult(null)
    setLoading(true)
    const formData = new FormData()
    formData.append("roll", roll)
    axios
      .post(`https://cp.sikhmissionarycollege.org/dpr/result`, formData)
      .then((res) => {
        if (res.data.status === 'success') {
          setResult(res.data.data)
          writeResultCache(roll, res.data.data)
          window.scrollTo({ top: 500, behavior: 'smooth' })
        } else {
          setError('No result found for this roll number.')
        }
      })
      .catch(() => {
        setError('Unable to connect to the server. Please try again.')
      })
      .finally(() => {
        setLoading(false)
      })
  }
  const resultGrade = () => {
    if (result) {
      if (result.grade === "f") {
        return "Fail";
      } else if (result.grade === "p") {
        return "Pass";
      } else if (result.grade === "m") {
        return "Merit";
      } else if (result.grade === "a") {
        return "A";
      } else if (result.grade === "b") {
        return "B";
      } else if (result.grade === "c") {
        return "C";
      } else {
        return "";
      }
    }
    return "";
  };

  const marksTable = () => {
    if ((result.attendanceStatus === "p") && (result.totalMarks !== null || result.gurbani !== null || result.gurmat !== null || result.ithas !== null)) {

      return (<>
        <table className="table table-bordered mytable">
          <tr>
            <th>ਵਿਸ਼ਾ/Subject</th>
            <th>ਕੁਲ ਅੰਕ /Total Marks</th>
            <th>ਪ੍ਰਾਪਤ ਅੰਕ /Obtained Marks</th>
          </tr>
          <tr>
            <td>ਗੁਰਬਾਣੀ/Gurbani</td>
            <td>100</td>
            <td>{result && result.gurbani}</td>
          </tr>
          <tr>
            <td>ਸਿੱਖ ਇਤਿਹਾਸ/Sikh Ithaas</td>
            <td>100</td>
            <td>{result && result.ithas}</td>
          </tr>
          <tr>
            <td>ਰਹਿਤ ਮਰਯਾਦਾ/Rehat Maryada</td>
            <td>100</td>
            <td>{result && result.gurmat}</td>
          </tr>
          <tr>
            <td>ਕੁਲ ਜੋੜ /Total</td>
            <td>300</td>
            <td>{result && result.totalMarks}</td>
          </tr>
        </table>
        <br />
        <table className="table table-dark table-bordered">
          <tr>
            <th>ਪ੍ਰਾਪਤ ਪ੍ਰਤੀਸ਼ਤ /Percentage</th>
            <td>{result && result.marksPercentage}%</td>
          </tr>
          <tr>
            <th>ਪ੍ਰਾਪਤ ਦਰਜਾ/Grade</th>
            <td>
              {resultGrade()}
            </td>
          </tr>
        </table>
      </>
      );
    } else if (result.attendanceStatus === "a") {
      return (
        <>
          <table className="table table-bordered mytable">
            <tr>
              <td>
                <h2>Absent</h2>
              </td>
            </tr>
          </table>
        </>
      )
    } else {
      return (
        <>
          <table className="table table-bordered mytable">
            <tr>
              <td>
                <h2 className='text-danger'>Status Unknown</h2>
              </td>
            </tr>
          </table>
        </>
      )
    }
  }
  return (
    <div className="App">
      <header className="App-header">
        <div className="print-header">
          <img src={`/logo13-02-22.png`} className="print-logo" alt="logo" />
          <div>
            <p className="print-eyebrow">ਸਿੱਖ ਮਿਸ਼ਨਰੀ ਕਾਲਜ, ਲੁਧਿਆਣਾ</p>
            <h1 className="print-title">ਧਾਰਮਿਕ ਪ੍ਰੀਖਿਆ ਦਾ ਨਤੀਜਾ</h1>
          </div>
        </div>
        <div className="hero-content">
          <div>
            <p className="eyebrow">ਸਿੱਖ ਮਿਸ਼ਨਰੀ ਕਾਲਜ, ਲੁਧਿਆਣਾ</p>
            <h1>ਧਾਰਮਿਕ ਪ੍ਰੀਖਿਆ ਦਾ ਨਤੀਜਾ</h1>
            <p className="subtitle">
              {seasonInfo?.name ? `ਨਤੀਜਾ ${seasonInfo.name} ਲਈ` : 'Roll number ਪਾ ਕੇ ਆਪਣਾ ਨਤੀਜਾ ਵੇਖੋ'}
            </p>
          </div>
          <img src={`/logo13-02-22.png`} className="App-logo" alt="logo" />
        </div>

        {showMaintenanceMessage ? (
          <div className="status-pill">
            Results are not available right now. Please try again soon.
          </div>
        ) : (
          showPendingMessage && (
            <div className="status-pill">
              Results for {seasonInfo?.name ?? 'this season'} have not been declared yet.
            </div>
          )
        )}

        {!showMaintenanceMessage && (
          <div className="form-card noprint">
            <h2>Roll Number ਨਾਲ ਲੌਗ ਇਨ ਕਰੋ</h2>
            <p className="form-helper">Punjabi ਅਤੇ English ਦੋਨੋਂ ਦੇ ਬੀਚ maintained ਹੈ</p>
            <Form
              onSubmit={(e) => {
              e.preventDefault()
              submit()
            }}
          >
            <Form.Group className="mb-3" controlId="formRoll">
              <Form.Label>ਰੋਲ ਨੰਬਰ/Roll Number</Form.Label>
              <Form.Control
                type="number"
                onChange={(e) => {
                  setRoll(e.target.value)
                }}
                placeholder="e.g., 123456"
                required
                disabled={loading}
              />
            </Form.Group>
            <Button variant="primary" type="submit" className="w-100" disabled={loading}>
              {loading ? (
                <>
                  <Spinner animation="border" size="sm" role="status" aria-hidden="true" />
                  <span className="ms-2">ਜਾਂਚ ਰਿਹਾ ਹੈ...</span>
                </>
              ) : (
                'ਨਤੀਜਾ ਦੇਖੋ/Check Result'
              )}
            </Button>
          </Form>
        </div>
        )}

        {error && (
          <div className="alert-banner noprint" role="alert">
            {error}
          </div>
        )}

        {seasonReady && result && (
          <div className="result-card">
            <div className="result-header">
              <div>
                <strong>ਨਤੀਜਾ ਵੇਰਵਾ</strong>
                <p className="muted-text">Roll: {result.rollNumber}</p>
              </div>
              <div className={`result-pill ${result.grade === 'f' ? 'fail' : 'pass'}`}>
                {resultGrade()}
              </div>
            </div>
            <div className="result-grid">
              <div>
                <p className="muted-text">ਨਾਮ/Name</p>
                <p>{result.name}</p>
              </div>
              <div>
                <p className="muted-text">Father Name</p>
                <p>{result.fatherName}</p>
              </div>
              <div>
                <p className="muted-text">School</p>
                <p>
                  {result.school?.name}
                  <br />
                  {formatSchoolAddress(result.school)}
                </p>
              </div>
              <div>
                <p className="muted-text">Class / Group</p>
                <p>
                  {result.class.label} / {result.group.id}
                </p>
              </div>
            </div>
            {marksTable()}
            <div className="print-row noprint">
              <Button variant="outline-info" size="sm" onClick={PRINT}>
                PRINT
              </Button>
            </div>
          </div>
        )}
        <section className="seo-content noprint">
          <h3>Sikh Missionary College Dharmik Parikhya</h3>
          <p>
            The Sikh Missionary College organizes an annual Dharmik Parikhya (religious examination) in October/November
            to promote Sikh heritage among the new generation. Thousands of schools and colleges participate, with prizes
            worth approximately 20 lakh rupees distributed every year.
          </p>
          <p>
            The objective is to create a strong connection between young Sikhs and their cultural roots. Through
            wide participation, the examination encourages students to learn about the Sikh religion, culture, and values.
          </p>
          <p>
            Sikh Missionary College's initiative is crucial for preserving Sikh values by providing incentives and recognition
            that motivate students to appreciate their heritage and ensure its continuation in future generations.
          </p>
        </section>
      </header>
      <footer className="site-footer">
        <div className="contact-block">
          <p>Contact for any information regarding results:</p>
          <p><strong>Sikh Missionary College</strong></p>
          <p>Contact: 9914421815</p>
          <p>
            E-mail: <a href="mailto:smc@sikhmissionarycollege.org">smc@sikhmissionarycollege.org</a>
          </p>
          <p>
            <a href="https://sikhmissionarycollege.org/p.5.contact-us.html" target="_blank" rel="noreferrer">https://sikhmissionarycollege.org/p.5.contact-us.html</a>
          </p>
        </div>
        <p>
          Results are conditional and not legal documents; verification may be required.
          <span>Powered by Arash Info Corporation, Ludhiana · Mobile: 9814790299</span>
        </p>
      </footer>
    </div>
  )
}

const formatSchoolAddress = (school) => {
  if (!school) return ''
  return [school.address1, school.address2, school.address3].filter(Boolean).join(' ') + `, ${school.city} (${school.code})`
}



function OnLoadModal(props) {
  const [modalShow, setModalShow] = React.useState(true);
  const handleClose = () => setModalShow(false);
  const handleShow = () => setModalShow(true);
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      onHide={handleClose}
      show={modalShow}
    >
      <Modal.Header >
        <Modal.Title id="contained-modal-title-vcenter">
         Dharmik Parikhya Result
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
        The results of "Dharmik Prikhya" has not been announced yet. Please continue to monitor this website for the latest updates, as the results will be posted here. Thank you for your patience.
        </p>
      </Modal.Body>
      <Modal.Footer>
        {/* <Button onClick={handleClose}>Close</Button> */}
      </Modal.Footer>
    </Modal>
  );
}
